var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliText", {
    ref: "phone",
    attrs: {
      disabled: _vm.disabled,
      label: _vm.label ?? "Phone",
      errors: _vm.errors,
      rules: _vm.rules.phone,
      "hide-details": _vm.hideDetails,
      validateOnBlur: "",
      phone: "",
      icon: "phone",
      placeholder: "10-digits",
    },
    on: { input: _vm.maskPhone },
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }